import api from './api'

export default {
  // Método para listar hosts com suporte a paginação, busca e filtros
  async listHosts(page = 1, limit = 20, all = false, search = '', filters = {}) {
    const params = new URLSearchParams();
    if (search && search.trim() !== '') {
      params.append('search', search.trim());
    } else if (all) {
      params.append('all', 'true');
    } else {
      params.append('page', page.toString());
      params.append('limit', limit.toString());
    }
    
    // Adicionar filtros se fornecidos
    if (filters.sistemas && filters.sistemas.length > 0) {
      params.append('sistemas', filters.sistemas.join(','));
    }
    if (filters.statusAtualizacao) {
      params.append('statusAtualizacao', filters.statusAtualizacao);
    }
    if (filters.macroMaster) {
      params.append('macroMaster', filters.macroMaster);
    }
    if (filters.macroMasterVersion) {
      params.append('macroMasterVersion', filters.macroMasterVersion);
    }
    if (filters.temCronograma) {
      params.append('temCronograma', filters.temCronograma);
    }
    
    return await api.get(`/hosts?${params.toString()}`)
  },

  // Método alternativo para compatibilidade
  async getHosts(page = 1, limit = 20, all = false) {
    return await this.listHosts(page, limit, all);
  },
  
  // Método para buscar um host pelo ID do Zabbix
  async getHostByZabbixId(zabbixId) {
    return await api.get(`/hosts/zabbix/${zabbixId}`)
  },

  async syncHosts() {
    return await api.post('/hosts/sync')
  },

  async getSystemVersions() {
    return await api.get('/system-versions')
  },

  async calcularScoreSeguranca(sistemas) {
    return await api.post('/hosts/calcular-score-seguranca', { sistemas })
  },

  /** Verifica se o host pode solicitar atualização do VSUP (VSUC deve estar em 8.04a ou superior). */
  async podeAtualizarVSUP(hostId) {
    return await api.get(`/hosts/${hostId}/pode-atualizar-vsup`)
  },

  // Métodos de atualização
  async updateHost(hostId, sistema) {
    return await api.post(`/hosts/${hostId}/atualizar`, { sistema })
  },

  async atualizarSistema(hostId, sistema) {
    return await api.post(`/hosts/${hostId}/atualizar`, { sistema })
  },

  async verificarAtualizacao(hostId, sistema) {
    return await api.post(`/hosts/${hostId}/verificarAtualizacao`, null, {
      params: { sistema }
    })
  },

  async verificarStatusAtualizacao(hostId, sistema, startTime) {
    return await api.get(`/hosts/${hostId}/verificar-atualizacao`, {
      params: { sistema, startTime }
    })
  },


  async getZabbixItemValue(hostId, itemKey) {
    return await api.get(`/hosts/${hostId}/zabbix-item`, {
      params: { itemKey }
    })
  },

  async verificarItens(hostId, sistema) {
    return await api.get(`/hosts/${hostId}/verificarItens`, {
      params: { sistema }
    })
  },

  async verificarItemsZabbix(hostId, sistema) {
    return await api.get(`/hosts/${hostId}/verificarItens`, {
      params: { sistema }
    })
  },

  async backupHost(hostId, sistema) {
    return await api.post(`/hosts/${hostId}/backup`, { sistema })
  },

  async syncSingleHost(hostId) {
    return await api.post(`/hosts/${hostId}/sync`)
  },

  async getStatusExecucao(hostId, sistema) {
    return await api.get(`/hosts/${hostId}/status-execucao`, {
      params: { sistema }
    })
  },

  async getEventosAtualizacao(hostId, sistema = null) {
    const params = sistema ? { sistema } : {}
    return await api.get(`/hosts/${hostId}/eventos-atualizacao`, { params })
  },

  async verificarAndamento(hostId) {
    return await api.get(`/hosts/${hostId}/verificar-andamento`)
  },

  // Métodos de cronograma
  async getCronogramas() {
    return await api.get('/cronogramas')
  },

  async getCronogramaByHostId(hostId) {
    return await api.get(`/hosts/${hostId}/cronograma`)
  },

  async createOrUpdateCronograma(cronogramaData) {
    return await api.post('/cronogramas', cronogramaData)
  },

  async deleteCronograma(cronogramaId) {
    return await api.delete(`/cronogramas/${cronogramaId}`)
  },

  async toggleCronograma(cronogramaId, jobsAgendados) {
    return await api.patch(`/cronogramas/${cronogramaId}/toggle`, { jobsAgendados })
  },

  async getJobsStatus(cronogramaId) {
    return await api.get(`/cronogramas/${cronogramaId}/jobs-status`)
  },

  // Métodos de logs
  async getHostLogs(hostId) {
    return await api.get(`/hosts/${hostId}/logs`)
  },

  async getLogsByHostId(hostId) {
    return await api.get(`/hosts/${hostId}/logs`)
  },

  async getLogsContent(hostId, sistema, dataFormatada) {
    return await api.get(`/hosts/${hostId}/logs/${sistema}/${dataFormatada}`)
  },

  async getLogFile(hostId, sistema, dataFormatada, nomeArquivo) {
    return await api.get(`/hosts/${hostId}/logs/${sistema}/${dataFormatada}/${nomeArquivo}`)
  },

  // Método para buscar dados de congestionamento por horário
  async getCongestionamentoHorarios() {
    return await api.get('/cronogramas/congestionamento-horarios')
  },

  // Método para buscar sugestão de horários
  async getSugestaoHorarios(horarioMinimo = null, quantidadeSistemas = 1) {
    const params = {}
    if (horarioMinimo) params.horarioMinimo = horarioMinimo
    if (quantidadeSistemas) params.quantidadeSistemas = quantidadeSistemas
    return await api.get('/cronogramas/sugestao-horarios', { params })
  },

  // Método para buscar versão do MacroMaster
  async getMacroMasterVersion() {
    return await api.get('/macromaster')
  },

  // Métodos de atualização manual cronogramada
  async getManualCronogramado(hostId) {
    return await api.get(`/hosts/${hostId}/manual-cronogramada`)
  },

  async createManualCronogramado(hostId, sistema, horario) {
    return await api.post(`/hosts/${hostId}/manual-cronogramada`, { sistema, horario })
  },

  async deleteManualCronogramado(hostId, sistema = null) {
    const url = sistema 
      ? `/hosts/${hostId}/manual-cronogramada?sistema=${sistema}`
      : `/hosts/${hostId}/manual-cronogramada`
    return await api.delete(url)
  },

  async verificarTemplatePadronizacao(hostId) {
    return await api.get(`/hosts/${hostId}/verificar-template-padronizacao`)
  },

  // Métodos de análise de ambiente
  async analisarAmbiente() {
    return await api.get('/cronogramas/analisar-ambiente')
  },

  async desativarCronogramasInconsistentes(cronogramaIds) {
    return await api.post('/cronogramas/desativar-inconsistentes', { cronogramaIds })
  },

  async ajustarHorariosConflito(inconsistencias) {
    return await api.post('/cronogramas/ajustar-horarios-conflito', { inconsistencias })
  },

  // Método para atualizar configurações de porta
  async updatePortaConfig(hostId, porta_bloqueio, porta_liberado) {
    return await api.patch(`/hosts/${hostId}/porta-config`, { porta_bloqueio, porta_liberado })
  },

  // Método para buscar atualizações de um host específico (sem filtros complexos)
  async getAtualizacoesByHostId(hostId) {
    // Busca simples: SELECT id, metodo, sistema, started_at FROM controle_atualizacoes WHERE hostid = ?
    return await api.get(`/hosts/${hostId}/atualizacoes`)
  },

  // Método para buscar log de uma atualização específica
  async getLogAtualizacao(atualizacaoId) {
    return await api.get(`/dashboard/logs/${atualizacaoId}`)
  }
} 